import React from 'react';
import { Link } from 'react-router-dom';

import CartImg3 from '../../img/star-profile-card.png';

export default function MyNFTs({
  totalSnftCount = 0,
  totalSnftAmount = 0,
  closeDrawer = () => {}
}) {
  return (
    <div className="my-buckes">
      <div className="balances mb-4">
        <div className="bal">
          <span>Campaign Clubs in my wallet</span>
          <span className="amount">{totalSnftCount}</span>
        </div>
        <div className="bal">
          <span>Total Staked</span>
          <span className="amount">${totalSnftAmount}</span>
        </div>
        <div className="liat-cart-slide">
          <div className="collecton px-4 pt-4">
            <div className="images large-img">
              <img
                style={{ width: '184px', height: '184px' }}
                src={CartImg3}
                alt=""
              />
            </div>
            <div className="details">
              <Link
                to="/StakeHub/MyBrandClubs"
                onClick={() => closeDrawer(true)}
                className="collection-link"
              >
                View My Portfolio
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
